var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChartPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 100C200 81.5075 194.872 63.3771 185.187 47.6239C175.501 31.8708 161.637 19.1119 145.135 10.7653C128.633 2.41868 110.14 -1.18869 91.7113 0.344106C73.2824 1.8769 55.6394 8.48982 40.7433 19.4479L100 100H200Z",
    fill: "#ADB5BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1231 17.7503C28.6804 27.7376 17.1221 41.3519 9.61083 57.2239C2.09951 73.0958 -1.10001 90.6658 0.33404 108.167C1.76809 125.668 7.78517 142.483 17.7801 156.92C27.775 171.357 41.3954 182.909 57.2713 190.412C73.1472 197.915 90.7189 201.105 108.219 199.662C125.719 198.218 142.531 192.193 156.963 182.19C171.395 172.188 182.939 158.561 190.434 142.681C197.929 126.801 201.11 109.228 199.657 91.7287L100 100L43.1231 17.7503Z",
    fill: "#373D43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartPreview);
export default __webpack_public_path__ + "static/media/pieChartPreview.f5a73f895858a320c19845d73b894d13.svg";
export { ForwardRef as ReactComponent };